import { inject as u } from "vue";
const o = "@css-render/vue3-ssr";
function i(e, n) {
  return `<style cssr-id="${e}">
${n}
</style>`;
}
function c(e, n, t) {
  const { styles: r, ids: s } = t;
  s.has(e) || r !== null && (s.add(e), r.push(i(e, n)));
}
const d = typeof document < "u";
function l() {
  if (d)
    return;
  const e = u(o, null);
  if (e !== null)
    return {
      adapter: (n, t) => c(n, t, e),
      context: e
    };
}
export {
  l as useSsrAdapter
};
